import { render } from "./TransferDetailsModal.vue?vue&type=template&id=54791644&scoped=true"
import script from "./TransferDetailsModal.vue?vue&type=script&lang=js"
export * from "./TransferDetailsModal.vue?vue&type=script&lang=js"

import "./TransferDetailsModal.vue?vue&type=style&index=0&id=54791644&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54791644"]])

export default __exports__